import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Grid, makeStyles, Typography } from "@material-ui/core";
import { ProSidebar, Menu, MenuItem, SidebarContent } from "react-pro-sidebar";

import { Icon } from "../../components/base/Icon";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRight: `1px solid ${COLORS.darks[0][10]}`,
  },
  expandRoot: {
    borderRight: `1px solid ${COLORS.darks[0][10]}`,
    boxShadow: `0px 12px 26px 0px ${COLORS.darks[0][6]}`,
  },
  hoveredIcon: {
    borderRadius: "50%",
    width: 45,
    height: 45,
  },
  menu: {
    marginTop: theme.spacing(4),
  },
  menuItem: {
    color: COLORS.darks[0][100],
    height: 90,
  },
  collapsedIconTitle: {
    color: COLORS.darks[0][25],
    lineHeight: 1,
    marginTop: theme.spacing(0.5),
  },
  menuText: {
    marginBottom: theme.spacing(2),
  },
  icon: {
    "& path": {
      fill: COLORS.davisGrey,
    },
    "&.selected path": {
      fill: COLORS.white,
      stroke: COLORS.white,
    },
  },
}));

export const LeftNav = ({ collapsed, navItems }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(navItems[0].text);

  useEffect(() => {
    let item = navItems.find((item) => item.path === location.pathname);
    if (!item) {
      if (navItems[0].text === "Dashboard") {
        navItems = navItems.slice(1);
      }
      item = navItems.find((item) => location.pathname.includes(item.path));
    }
    setSelectedMenu(!item ? "Dashboard" : item.text);
  }, [location.pathname, navItems]);

  const onItemHover = (index) => {
    setHoveredItem(index);
  };

  const onItemClick = (item) => {
    setSelectedMenu(item.text);
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <ProSidebar
      width={210}
      className={collapsed ? classes.root : classes.expandRoot}
      collapsed={collapsed}
    >
      <SidebarContent>
        <Menu className={classes.menu}>
          {navItems.map((item, index) => (
            <MenuItem
              id={item.id}
              onMouseEnter={() => onItemHover(index)}
              onMouseLeave={() => setHoveredItem(null)}
              className={classes.menuItem}
              key={index}
              onClick={() => onItemClick(item)}
              icon={
                <>
                  <Grid
                    container
                    className={classes.hoveredIcon}
                    alignItems="center"
                    justifyContent="center"
                    style={{
                      backgroundColor:
                        selectedMenu === item.text || hoveredItem === index
                          ? COLORS.purple
                          : "transparent",
                      paddingBottom: item.id === "dashboard-nav" ? 8 : null,
                    }}
                  >
                    <Icon
                      src={
                        selectedMenu === item.text || hoveredItem === index
                          ? item.iconSelected
                          : item.icon
                      }
                      hoverable
                    />
                  </Grid>
                  {collapsed ? (
                    <Typography
                      className={classes.collapsedIconTitle}
                      align="center"
                      variant="body2"
                      style={{
                        visibility: hoveredItem === index ? "visible" : "hidden",
                      }}
                    >
                      {item.text}
                    </Typography>
                  ) : null}
                </>
              }
            >
              {item.text}
            </MenuItem>
          ))}
        </Menu>
      </SidebarContent>
    </ProSidebar>
  );
};
